import { AnimatePresence, motion } from "@/lib/motion";
import { X, CalendarClock, Mail } from "lucide-react";

// Fallback scheduler, shown only if a CTA has no URL from Sanity. Keep in sync with
// Sanity navigation.primaryCta.url (the Google Calendar appointment page).
const SCHEDULER_URL =
    "https://calendar.google.com/calendar/appointments/schedules/AcZssZ3KdUotrf3MPu2knRy23NbK04mmdK0dzxmCkaaeNH8YYdUwjZVw_jDWBjPZ78Bp0vgjGe7Zoi96?gv=true";

export const BookDialog = ({ open, onClose }) => (
    <AnimatePresence>
        {open && (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                data-testid="book-dialog-overlay"
                onClick={onClose}
                className="fixed inset-0 z-[60] grid place-items-center bg-black/50 p-5"
            >
                <motion.div
                    initial={{ opacity: 0, y: 24, scale: 0.97 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 24, scale: 0.97 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    onClick={(e) => e.stopPropagation()}
                    data-testid="book-dialog"
                    className="relative w-full max-w-md overflow-hidden rounded-3xl border border-brand-line bg-brand-bg p-8 shadow-2xl"
                >
                    <button
                        onClick={onClose}
                        data-testid="book-dialog-close"
                        aria-label="Close"
                        className="absolute right-5 top-5 grid h-9 w-9 place-items-center rounded-full border border-brand-line text-brand-muted transition-colors duration-150 hover:bg-brand-surface2"
                    >
                        <X className="h-4 w-4" />
                    </button>

                    <span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-accent text-brand-on-accent">
                        <CalendarClock className="h-6 w-6" />
                    </span>
                    <h3 className="mt-6 font-heading text-2xl font-bold tracking-tight text-brand-text">
                        Schedule a Conversation
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-brand-muted">
                        A focused, no-pressure conversation with our team about becoming
                        secure, structured, and scalable.
                    </p>

                    {SCHEDULER_URL ? (
                        <a
                            href={SCHEDULER_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="book-dialog-scheduler"
                            className="mt-7 block w-full rounded-control bg-brand-accent px-6 py-3.5 text-center text-sm font-semibold text-brand-on-accent transition-colors duration-150"
                        >
                            Choose a time
                        </a>
                    ) : (
                        <div className="mt-7 space-y-3">
                            <div className="rounded-2xl border border-dashed border-brand-line bg-brand-surface p-4 text-center">
                                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-muted">
                                    Scheduler connects soon
                                </p>
                            </div>
                            <a
                                href="mailto:info@easilinked.com?subject=Schedule%20a%20Conversation"
                                data-testid="book-dialog-email"
                                className="flex w-full items-center justify-center gap-2 rounded-control bg-brand-primary px-6 py-3.5 text-sm font-semibold text-brand-on-primary transition-colors duration-150"
                            >
                                <Mail className="h-4 w-4" />
                                Reach us by email
                            </a>
                        </div>
                    )}
                </motion.div>
            </motion.div>
        )}
    </AnimatePresence>
);
